module.exports = __webpack_public_path__ + "static/media/Students-in-fall.1d7d1955.jpg";